import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { loginApi, loginErr } from "../../api/account/loginApi";
import Logo from "../../assets/chargingadda-logo.png";
import "./LoginPage.scss";

/**
 * Landing page for the password-reset email (authz-api /login/forgot asks
 * Zitadel to link here: /reset-password?user=<id>&code=<code>).
 */
const ResetPassword: React.FC = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const userId = params.get("user") || params.get("userID") || "";
  const code = params.get("code") || "";

  const [pw, setPw] = useState({ a: "", b: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (pw.a.length < 8) return setError("Use at least 8 characters.");
    if (pw.a !== pw.b) return setError("Passwords do not match.");
    setBusy(true);
    setError("");
    try {
      await loginApi.reset(userId, code, pw.a);
      setDone(true);
    } catch (err) {
      setError(loginErr(err, "Could not reset the password").message);
    } finally {
      setBusy(false);
    }
  };

  const invalid = !userId || !code;

  return (
    <div className="lgn-page">
      <div className="lgn-card">
        <img className="lgn-brand" src={Logo} alt="ChargingAdda" />
        {invalid ? (
          <>
            <h1 className="lgn-title">Invalid reset link</h1>
            <p className="lgn-sub">This link is incomplete. Request a new one from the sign-in page.</p>
            <button className="lgn-btn lgn-btn--primary" onClick={() => navigate("/login")}>Go to sign in</button>
          </>
        ) : done ? (
          <>
            <h1 className="lgn-title">Password updated</h1>
            <p className="lgn-sub">You can sign in with your new password now.</p>
            <button className="lgn-btn lgn-btn--primary" onClick={() => navigate("/login")}>Sign in</button>
          </>
        ) : (
          <form className="lgn-form" onSubmit={submit}>
            <div>
              <h1 className="lgn-title">Choose a new password</h1>
              <p className="lgn-sub">Your organisation's password rules still apply.</p>
            </div>
            <label>
              New password
              <input type="password" autoFocus autoComplete="new-password" minLength={8} value={pw.a}
                     onChange={(e) => setPw({ ...pw, a: e.target.value })} required />
            </label>
            <label>
              Confirm new password
              <input type="password" autoComplete="new-password" minLength={8} value={pw.b}
                     onChange={(e) => setPw({ ...pw, b: e.target.value })} required />
            </label>
            {error && <div className="lgn-error">{error}</div>}
            <button className="lgn-btn lgn-btn--primary" type="submit" disabled={busy}>
              {busy ? "Saving..." : "Set password"}
            </button>
          </form>
        )}
        <div className="lgn-foot">Secured by ChargingAdda</div>
      </div>
    </div>
  );
};

export default ResetPassword;
